import { Mail, Phone, User } from "lucide-react"
import { useTranslation } from "react-i18next"

const ManagerInfoBlock = ({ manager, showName = true, showPhone = true, showEmail = true }) => {
  const { t } = useTranslation()

  if (!manager) return null

  const hasName = showName && manager.name
  const hasPhone = showPhone && manager.phone
  const hasEmail = showEmail && manager.email

  if (!hasName && !hasPhone && !hasEmail) return null

  return (
    <div className="bg-white rounded-2xl border border-[#E7EAEF] px-4 sm:px-5 py-3 sm:py-4 mb-4">
      <div className="text-xs uppercase tracking-wide text-[#9AA5B4] mb-2">
        {t("saved_tours.branding.manager_block_title", "Ваш менеджер")}
      </div>
      <div className="flex flex-wrap items-center gap-x-4 sm:gap-x-6 gap-y-1.5 text-sm text-[#26303D]">
        {hasName && (
          <span className="flex items-center gap-1.5 min-w-0 break-words">
            <User size={14} className="text-[#9AA5B4] shrink-0" />
            {manager.name}
          </span>
        )}
        {hasPhone && (
          <a
            href={`tel:${manager.phone}`}
            className="flex items-center gap-1.5 min-w-0 hover:text-[#1E9E5B]"
          >
            <Phone size={14} className="text-[#9AA5B4] shrink-0" />
            <span className="break-all">{manager.phone}</span>
          </a>
        )}
        {hasEmail && (
          <a
            href={`mailto:${manager.email}`}
            className="flex items-center gap-1.5 min-w-0 hover:text-[#1E9E5B]"
          >
            <Mail size={14} className="text-[#9AA5B4] shrink-0" />
            <span className="break-all">{manager.email}</span>
          </a>
        )}
      </div>
    </div>
  )
}

export default ManagerInfoBlock
